import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../../Spinner";
import { formatDate, limitParagraphByCharLimit } from "../../../Helper/Helper";
import { SendPostRequest } from "../../../http";
import FooterWrapper from "../../Footer/FooterWrapper";

function BlogsGridNews() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNewsData();
    window.scrollTo(0, 0);
  }, []);

  const getNewsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("news/list");
      setNewsData(response?.data);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="News and Updates" Image="theme-2-banner-news.webp"/>

        <div className="container">
          {loading ? (
            <div className="d-flex justify-content-center pt-5">
              <Spinner />
            </div>
          ) : newsData?.length > 0 ? (
            <div className="row service-main-wrapper pt-5">
              {newsData.map((data, index) => (
                <div className="col-md-4 mb-5" key={index}>
                  <div className="item" key={index}>
                    <div className="blog-main-wrapper blog-style-1">
                      <div className="blog-inner" style={{ height: "460px" }}>
                        <div className="blog-thumb relative">
                          <img
                            src={data?.image}
                            className="img-fluid"
                            width="100%"
                            height="auto"
                            alt="blog-img"
                          />
                          <div className="top-meta">
                            <ul className="top-meta-list">
                              <li>
                                <div className="post-date">
                                  <Link
                                    to={`/news/detail/${data?.slug}`}
                                  >
                                    <i className="ti-calendar"></i>
                                    {formatDate(data?.date)}
                                  </Link>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="blog-details pt-0">
                          <div className="blog-title">
                            <h4 className="margin-bottom-10">
                              <Link
                                to={`/news/detail/${data?.slug}`}
                                className="blog-name"
                              >
                                {data?.title}
                              </Link>
                            </h4>
                          </div>
                          <div className="post-desc mt-2">

                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  limitParagraphByCharLimit(data?.content, 75) +
                                  ((data?.content?.replace(/<[^>]*>/g, "").length || 0) > 75 ? "..." : ""),
                              }}

                            />
                            <div className="blog-link">
                              <Link
                                to={`/news/detail/${data?.slug}`}
                                className="link font-w-500"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="col-12 text-center my-5 py-5">
              <h4>No Record Available</h4>
            </div>
          )}
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default BlogsGridNews;